module.exports = "<div class=\"copyright\">© {{vendorTitle}} 2018. All Rights Reserved.</div>\n<div class=\"version\">Version {{version}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/footer/footer.component.html
// module id = ./src/app/Dashboard/footer/footer.component.html
// module chunks = main